export default {
    person: {
        name:'张三',
        hobby:'唱跳，rap，篮球'
    },
};